module.exports = __webpack_public_path__ + "static/img/list-img00.4663b18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list-img00.png
// module id = Rx6a
// module chunks = 0